import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import SectionHeader from '../components/SectionHeader';
import '../styles/ContactPage.css';
import SEO from '../components/SEO';

const ContactPage: React.FC = () => {

  return (
    <>
      <SEO
        title="Contact Us"
        description="Get in touch with Empower Future 21 (EF21) to explore partnerships, support our work, join our team, or learn more about our programmes in crisis-affected Myanmar."
        keywords="contact EF21, Empower Future 21, partnership, donate, careers, humanitarian, Myanmar, education in emergencies"
      />
      <Hero
        title="Get Involved"
        subtitle="Work with us to strengthen education and resilience in crisis-affected Myanmar"
      />

      <section className="contact-section">
        <div className="container">
          <SectionHeader
            title="Get in Touch"
            subtitle="Reach out to explore partnerships, support our programmes, or learn more about our work alongside conflict-affected communities."
          />

          <div className="contact-content">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <h3>Email Us</h3>
              <p className="contact-description">
                Send us an email and we'll get back to you as soon as possible.
              </p>
              <a href="mailto:contact@empowerfuture21.org" className="contact-email">
                contact@empowerfuture21.org
                
              </a>
            </div>

            <div className="involvement-card">
              <h3>Ways to Get Involved</h3>
              <div className="involvement-grid">
                <a href="mailto:contact@empowerfuture21.org?subject=Partnership%20enquiry" className="involvement-item">
                  <span className="involvement-icon">🤝</span>
                  <h4>Partner with EF21</h4>
                  <p>Collaborate on locally led responses</p>
                </a>
                <Link to="/donate" className="involvement-item">
                  <span className="involvement-icon">💝</span>
                  <h4>Support Our Work</h4>
                  <p>Fund education and resilience programmes</p>
                </Link>
                <Link to="/careers" className="involvement-item">
                  <span className="involvement-icon">💼</span>
                  <h4>Join Our Team</h4>
                  <p>See our current vacancies</p>
                </Link>
                <a href="mailto:contact@empowerfuture21.org" className="involvement-item">
                  <span className="involvement-icon">📧</span>
                  <h4>Contact Us</h4>
                  <p>Ask a question or request information</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;